import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, CheckCircle2, ArrowRight, Flame } from "lucide-react";
import api from "@/lib/api";

export const PacksSection = () => {
  const [d, setD] = useState(null);
  const navigate = useNavigate();
  useEffect(() => { api.get("/packs").then((r) => setD(r.data)).catch(() => {}); }, []);
  if (!d) return null;
  return (
    <section className="space-y-3" data-testid="packs-section">
      <div>
        <div className="text-[11px] font-mono uppercase tracking-widest text-tc-xp flex items-center gap-1.5"><Flame className="w-3.5 h-3.5" /> Famous-day packs</div>
        <p className="text-xs text-tc-muted mt-1">{d.disclaimer}</p>
      </div>
      <div className="grid gap-3 lg:grid-cols-3">
        {d.packs.map((p) => (
          <div key={p.id} className={`tc-card p-4 space-y-2 ${p.unlocked ? "" : "opacity-80"}`} data-testid={`pack-${p.id}`}>
            <div className="flex items-center justify-between gap-2">
              <h3 className="font-heading font-bold">{p.name} <span className="text-tc-muted font-normal text-sm">· {p.period}</span></h3>
              {p.unlocked ? <span className="text-[10px] font-mono text-tc-bull" data-testid={`pack-${p.id}-open`}>OPEN</span>
                : <span className="text-[10px] font-mono text-tc-muted flex items-center gap-1 whitespace-nowrap shrink-0" data-testid={`pack-${p.id}-locked`}><Lock className="w-3 h-3" /> {p.requirement}</span>}
            </div>
            <p className="text-sm text-tc-sub">{p.blurb}</p>
            <p className="text-xs"><span className="text-tc-xp font-semibold">Lesson:</span> {p.lesson}</p>
            <p className="text-[11px] text-tc-muted" data-testid={`pack-${p.id}-honesty`}>{p.honesty}</p>
            <div className="space-y-1.5 pt-1">
              {p.scenarios.map((s) => (
                <button key={s.id} disabled={!p.unlocked} data-testid={`pack-scenario-${s.id}`}
                  onClick={() => navigate(`/replay?scenario=${s.id}`)}
                  className="w-full text-left rounded-lg border border-white/10 px-3 py-2 text-sm flex items-center justify-between gap-2 hover:border-white/30 transition-colors disabled:cursor-not-allowed disabled:hover:border-white/10">
                  <span className="min-w-0">
                    <span className="block font-medium truncate">{s.name}</span>
                    <span className="block text-[11px] text-tc-muted font-mono">{s.symbol} · {s.interval} · {s.date_window}</span>
                  </span>
                  {s.completed ? <CheckCircle2 className="w-4 h-4 text-tc-bull shrink-0" /> : p.unlocked ? <ArrowRight className="w-4 h-4 shrink-0" /> : <Lock className="w-4 h-4 shrink-0 text-tc-muted" />}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
